import { ISelectFieldsConfig } from './eventOptions';

export enum RoleEntity {
  CUSTOMERS = 'CUSTOMERS',
  CUSTOMER_FIELDS = 'CUSTOMER_FIELDS',
  EVENTS = 'EVENTS',
  SERVICES = 'SERVICES',
  SERVICE_GROUPS = 'SERVICE_GROUPS',
  RESOURCES = 'RESOURCES',
  ENTERPRISES = 'ENTERPRISES',
  COMPANIES = 'COMPANIES',
  TIME_SHIFTS = 'TIME_SHIFTS',
  ACCESS_TOKEN = 'ACCESS_TOKEN',
  NOTIFICATION = 'NOTIFICATION',
  BM_ACCESS_TOKEN = 'BM_ACCESS_TOKEN',
  BM_MANAGERS = 'BM_MANAGERS',
  TAGS = 'TAGS',
}

export enum RoleType {
  READ = 'READ',
  WRITE = 'WRITE',
  DELETE = 'DELETE',
}

export const rolesOptions = [
  {
    value: RoleEntity.CUSTOMERS,
    label: 'app.scope.roles.customers',
  },
  {
    value: RoleEntity.CUSTOMER_FIELDS,
    label: 'app.scope.roles.customerFields',
  },
  {
    value: RoleEntity.EVENTS,
    label: 'app.scope.roles.events',
  },
  {
    value: RoleEntity.SERVICES,
    label: 'app.scope.roles.services',
  },
  {
    value: RoleEntity.SERVICE_GROUPS,
    label: 'app.scope.roles.serviceGroups',
  },
  {
    value: RoleEntity.RESOURCES,
    label: 'app.scope.roles.resources',
  },
  {
    value: RoleEntity.COMPANIES,
    label: 'app.scope.roles.companies',
  },
  {
    value: RoleEntity.TIME_SHIFTS,
    label: 'app.scope.roles.timeShifts',
  },
  {
    value: RoleEntity.ACCESS_TOKEN,
    label: 'app.scope.roles.accessToken',
  },
  {
    value: RoleEntity.NOTIFICATION,
    label: 'app.scope.roles.notification',
  },
  {
    value: RoleEntity.BM_ACCESS_TOKEN,
    label: 'app.scope.roles.bmAccessToken',
  },
  {
    value: RoleEntity.BM_MANAGERS,
    label: 'app.scope.roles.bmManagers',
  },
  {
    value: RoleEntity.ENTERPRISES,
    label: 'app.scope.roles.enterprises',
  },
  {
    value: RoleEntity.TAGS,
    label: 'app.scope.roles.tags',
  },
];

export const rolesTypes = Object.keys(RoleType);

export const rolesConfig: ISelectFieldsConfig<RoleType> = Object.keys(RoleEntity).reduce(
  (acc, role) => ({ ...acc, [role]: rolesTypes }),
  {}
);

type CheckDisabled = (type: string, values: string[]) => boolean;

export const checkDisabledRoles: CheckDisabled = (type, values) =>
  type === RoleType.READ || (type === RoleType.DELETE && !values.includes(RoleType.WRITE));

export interface IEntity {
  name: string;
  types: string[];
}

export const filterTypes = (entity: IEntity[]): IEntity[] =>
  entity.map((item) => ({
    ...item,
    types:
      item.types.includes(RoleType.DELETE) && !item.types.includes(RoleType.WRITE)
        ? item.types.slice(0, 2)
        : item.types,
  }));
